/**
 * Returns the tenant identifier used in API path parameters.
 * Configured per environment via TENANT_ID env var.
 * TODO: Replace with a JWT token claim once BE adds tenant_identifier to the MSAL access token.
 */
export function useTenantId(): string {
	return import.meta.env.TENANT_ID;
}
